import { Filter } from '@selfai-platform/bi-domain';

export function isTimeRelativeFilter(filter: Filter): boolean {
  return filter.type === 'time_relative';
}
